(function() {
    'use strict';
    angular
        .module('sigmasfApp')
        .factory('OfferStatus', OfferStatus);

    OfferStatus.$inject = ['$resource'];

    function OfferStatus ($resource) {
        var resourceUrl =  'api/offer-statuses/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
